import React from "react";

// auth
import ConfirmMail from "../views/dashboard/auth/confirm-email";
import RecoverPassword from "../views/dashboard/auth/recover-password";
import SignIn from "../views/dashboard/auth/sign-in";
import AdminSignIn from "../views/dashboard/auth/admin-sign-in";
// errors
import Error404 from "../views/dashboard/errors/error404";
import Error500 from "../views/dashboard/errors/error500";
import ForgotPassword from "../views/dashboard/auth/forgot-password";

export const PublicRouter = [
  {
    path: "admin/auth/sign-in",
    element: <AdminSignIn />,
  },
  {
    path: "user/auth/sign-in",
    element: <SignIn />,
  },
  {
    path: "user/auth/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "user/auth/success-email",
    element: <ConfirmMail />,
  },
  {
    path: "user/auth/recover-password/:token?/:email?",
    element: <RecoverPassword />,
  },
  {
    path: "*",
    element: <Error404 />,
  },
  {
    path: "errors/error500",
    element: <Error500 />,
  },
];
